import React, { Component } from 'react'
import { Link } from 'react-router'

import FilterEditor from './FilterEditor/'
import ActionEditor from './ActionEditor/'
import NewRuleConfirmation from './NewRuleConfirmation/'
import { Button } from '@driftt/tide-core-legacy'
import { api } from 'app/modules/rules/api'
import { api as sfdcApi } from 'app/modules/sfdc/api'
import { patchSalesforceToggles } from 'app/modules/integrations/api'
import withNotifications from 'components/shared/notifications'
import PropTypes from 'prop-types'
const ADD_FILTER = 'ADD'

class RulesEditor extends Component {

  static contextTypes = {
    router: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      saveSFDCSettings: false,
      saveSFDCToggles: false,
      ruleIsSaving: false,
    }
  }

  getEditorComponent() {

    const components = {
      'filterEditor': <FilterEditor {...this.props} />,
      'actionEditor': <ActionEditor {...this.props} />,
      'newRuleConfirmation': <NewRuleConfirmation {...this.props} />
    }

    return components[this.props.activePage]
  }

  getNextButtonText = () => {
    if (_.get(this.props, 'activeFilter.field') === 'salesforceOwner')
    {
      switch (this.props.activePage) {
        case 'newRuleConfirmation':
          return 'Publish'
        default:
          return 'Continue'
      }
    } else {
      switch (this.props.activePage) {
        case 'newRuleConfirmation':
          return 'Publish'
        default:
          return 'Save and Continue'
      }
    }
  }

  onPublish = () => {
    const notifyAndReroute = msg => () => {
      this.props.notifications.success(msg)
      this.context.router.push('/settings/rules')
    }

    this.setState({ ruleIsSaving: true })

    const publishSFDCSettings = () => {
      sfdcApi.patchSalesforceLeadRoutingSettings(this.props.salesforceLeadRoutingSettings)
    }

    const publishSFDCToggles = () => {
      patchSalesforceToggles(this.props.salesforceLeadRoutingToggles)
    }

    if (this.state.saveSFDCSettings === true) {
      publishSFDCSettings()
    }

    if (this.state.saveSFDCToggles === true) {
      publishSFDCToggles()
    }

    if (this.isEditing()) {
      api.editRule(this.props.rule.data.item, this.props.rule.data.item.id)
        .then(notifyAndReroute(`Your rule was successfully updated!`))
    } else {
      api.createRule(this.props.rule.data.item)
        .then(notifyAndReroute(`You've successfully created a new rule!`))
    }
  }

  shouldPublishLeanDataRule = () => {
    const {
      activeFilter,
      activePage,
    } = this.props

    return activeFilter && activeFilter.field && activeFilter.field === 'leandata' && activePage === 'filterEditor'
  }

  publishLeanDataRule = () => {
    const notifyAndReroute = msg => () => {
      this.props.notifications.success(msg)
      this.context.router.push('/settings/rules')
    }

    const ruleData = this.props.rule.data.item

    ruleData.name = 'LeanData Rule'

    this.setState({
      ruleIsSaving: true,
    })
    if (this.isEditing()) {
      api.editRule(ruleData, ruleData.id)
        .then(notifyAndReroute(`Your rule was successfully updated!`))
    } else {
      api.createRule(ruleData)
        .then(notifyAndReroute(`You've successfully created a new rule!`))
    }
  }

  saveAndGetNextActivePage = () => {
    const thereAreFilters = this.props.rule.data.item.conditions[0] &&
      this.props.rule.data.item.conditions[0].length

    const isAvailabilityRule = (this.props.rule.data.item.id && (this.props.rule.data.item.conditions.length === 0 || this.props.rule.data.item.conditions[0].length === 0)) || this.props.activeFilter.field === 'onlineUsers'

    if (this.shouldPublishLeanDataRule()) {
      this.publishLeanDataRule()
      return 'filterEditor'
    }

    switch (this.props.activePage) {
      case 'filterEditor':
        if (this.props.activeFilter !== 'ADD') {
          this.props.saveActiveFilter()
        }
        return 'actionEditor'
      case 'actionEditor':
        if (isAvailabilityRule) {
          this.props.saveActiveFilter()
          return 'newRuleConfirmation'
        }
        return thereAreFilters
          ? 'newRuleConfirmation'
          : 'filterEditor'
      case 'newRuleConfirmation':
        this.onPublish()
        return 'newRuleConfirmation'
      default:
        return 'filterEditor'
    }
  }

  onSave = () => {
    this.props.setActivePage(this.saveAndGetNextActivePage())
  }

  onPrevious = () => {
    if (_.get(this.props, 'activeFilter.field') === 'salesforceOwner' || _.get(this.props, 'activeFilter.field') === 'targetedAccounts') {
      this.props.resetActiveRuleAction(this.props.rule)
    }

    const getLastValidFilter = () => {
      const addConditions = _.head(this.props)
      return _.last(addConditions)
    }

    const processAndGetPrevious = () => {
      switch (this.props.activePage) {
        case 'filterEditor':
          this.props.activeFilter === ADD_FILTER
            ? this.props.setActiveFilter(getLastValidFilter())
            : this.props.setActiveFilter(ADD_FILTER)
          return 'filterEditor'
        case 'actionEditor':
          return 'filterEditor'
        case 'newRuleConfirmation':
          return 'actionEditor'
        default:
          return 'filterEditor'
      }
    }

    this.props.setActivePage(processAndGetPrevious())
  }

  shouldShowNavigation = () => {
    const hasNoFilters = !(this.props.rule.data.item.conditions[0] && this.props.rule.data.item.conditions[0].length)
    return !(this.props.activePage === 'filterEditor' && this.props.activeFilter === 'ADD' && hasNoFilters)
  }

  canSave = () => {
    const {
      ruleIsSaving,
    } = this.state

    return !ruleIsSaving && (this.props.currentPageIsValid || (
      this.props.activePage === 'filterEditor' &&
      this.props.activeFilter === 'ADD'
    ))
  }

  isEditing = () => !!this.props.rule.data.item.id

  componentDidUpdate(prevProps) {
    const {
      salesforceLeadRoutingSettings,
      salesforceLeadRoutingToggles
    } = this.props

    if (salesforceLeadRoutingSettings !== prevProps.salesforceLeadRoutingSettings) {
      this.setState({ saveSFDCSettings: true })
    }

    if (salesforceLeadRoutingToggles !== prevProps.salesforceLeadRoutingToggles) {
      this.setState({ saveSFDCToggles: true })
    }
  }

  render() {
    const {
      ruleIsSaving,
    } = this.state

    return (
      <div className="rules-editor">
        <header>
          <div className="rules-breadcrumbs">
            <Link to="/settings/rules" className="breadcrumb-back">Team Settings / Conversation Routing</Link>
            <h1>{ this.isEditing() ? 'Edit your rule' : 'Create a new rule'}</h1>
          </div>
          <div className="header-right-nav">
           {this.shouldShowNavigation() && !(_.get(this.props, 'activeFilter.field') === 'salesforceOwner') && <button className="previous-step-button" onClick={this.onPrevious}>&lt; Previous Step</button>}
            {this.shouldShowNavigation() && <Button type="primary" loading={ruleIsSaving} onClick={this.onSave} disabled={!this.canSave()}>{this.getNextButtonText()}</Button>}
            <Link to="/settings/rules" className="drift-button">Close</Link>
          </div>
        </header>

        <section>
        	{ this.getEditorComponent() }
        </section>
      </div>
    )
  }
}

export default withNotifications(RulesEditor)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/RulesEditor.js